import './style.css';

import React, { useEffect, useState } from 'react';
import { Spinner } from '@economic/gaudi';
import { useLocalization, t } from '../../l10n/l10n';

export default function SpinnerWithText() {
    const [text, setText] = useState('');
    const loading = useLocalization(textIds);

    useEffect(() => {
        if (loading) {
            return;
        }

        setText(t`LOADING_TEXT1`);

        const timeout = setTimeout(() => {
            setText(t`LOADING_TEXT2`);
        }, 10 * 1000);
        const timeout2 = setTimeout(() => {
            setText(t`LOADING_TEXT3`);
        }, 60 * 1000);

        return () => {
            clearTimeout(timeout);
            clearTimeout(timeout2);
        };
    }, [loading]);

    return (
        <div className="spinner-with-text flex flex-col items-center absolute">
            <Spinner />
            <div>{text}</div>
        </div>
    );
}

const textIds = ['LOADING_TEXT1', 'LOADING_TEXT2', 'LOADING_TEXT3'];
